<template>
    <div class="no_group">
        <div class="group_status">
            <div>
                距离拼团结束
                <span>{{time[0]}}</span>
                :
                <span>{{time[1]}}</span>
                :
                <span>{{time[2]}}</span>                
            </div>
            <span>拼团中</span>
        </div>
        <p class="title">{{productData.groupName}}</p>
        <groupPerson :headList="productData.groupInfo.headList"></groupPerson>
        <p class="rest_group_num">还差<span>{{productData.groupInfo.leftPeopleNumber}}</span>人成团 ，快来邀请好友拼单吧～</p>
        <button>
            <img src="https://appd.knowbox.cn/ss/activity/group-buy/wx-logo.png" alt="">
            <span v-if="isRunInWeChat" @click="handleToggle">分享到微信群</span>
            <span v-else @click="shareToHandler">分享到家长群</span>           
        </button>
        <div class="tips"> 
            <img src="https://appd.knowbox.cn/ss/activity/group-buy/remind-icon.png" alt="">
            分享到<span>3</span>个家长群拼团成功率可达<span>95%</span>
        </div>
        <groupSkillsPopup @close="close"  @share="shareToHandler" v-show="isShowPopup"></groupSkillsPopup>
        <browserMask
          :header="maskImg.header"
          :footer="maskImg.footer"
          @close="handleToggle"
          v-show="showMask">
        </browserMask>
    </div>
</template>

<script>
import groupPerson from "./group_person.vue";
import groupSkillsPopup from "./group_skills_popup.vue";
import { clearTimeout } from "timers";
import { share } from "../../../utils/hybird";
import { isRunInWeChat, isIOS } from "../../../utils/env";
import wx from 'weixin-js-sdk'
import utils from "@/assets/js/utils";
import browserMask from "@/components/common/browserMask";

export default {
  name: "no_group",
  props: {
    productData: Object,
  },
  data() {
    return {
      time: [],
      shareUrl: "",
      isShowPopup: false,
      isRunInWeChat: isRunInWeChat(),
      maskImg:{
        footer: isIOS() ? "https://appd.knowbox.cn/ss/activity/group-buy/share/iOS_2.png" : "https://appd.knowbox.cn/ss/activity/group-buy/share/android_2.png",
        header: isIOS() ? "https://appd.knowbox.cn/ss/activity/group-buy/share/iOS_1.png" : "https://appd.knowbox.cn/ss/activity/group-buy/share/android_1.png",
      },
      showMask: false,
    };
  },
  components: {
    groupPerson,
    groupSkillsPopup,
    browserMask,
  },
  created: function() {
    this.groupInfoId = utils.getQueryString("groupInfoId");
    this.groupId = utils.getQueryString("groupId");
  },
  mounted() {
    window.shareCallback ||
      (window.shareCallback = res => {
        console.log(res);
        if (res === "success") {
        } else if (res === "cancel") {
          // isIOS() && this.$toast('分享取消');
        } else {
          // this.$toast('分享失败');
        }
      });
    this.shareUrl =  window.location.origin + window.location.pathname + '#/group_buy/h5_detail?' + 'groupInfoId='+ this.groupInfoId +'&groupId='+ this.groupId + '&pageChannel=' + localStorage.getItem('pageChannel'),
    console.log('shareUrl',this.shareUrl)
  },
  watch:{
    productData(){
      this.timeDown(this.productData.groupInfo.endTime);
    }
  },
  methods: {
    handleToggle() {
      this.showMask = !this.showMask;
    },
    /*
    时间倒计时插件
    TimeDown.js
    */
    timeDown(totalSeconds) {
      var time = [];
      //小时数
      var hours = Math.floor(totalSeconds / (60 * 60)) < 10 ? '0' +  Math.floor(totalSeconds / (60 * 60)) : Math.floor(totalSeconds / (60 * 60));
      var modulo = totalSeconds % (60 * 60);
      //分钟
      var minutes = Math.floor(modulo / 60) < 10 ? '0' + Math.floor(modulo / 60) : Math.floor(modulo / 60) ;
      //秒
      var seconds = modulo % 60 < 10 ? '0' +  modulo % 60 :  modulo % 60;
      //输出到页面
      time.push(hours, minutes, seconds);
      this.time = time;
      //延迟一秒执行自己
      let timer = setTimeout(()=> {
        if (totalSeconds == 0) {
          clearTimeout(timer);
          return;
        }
        this.timeDown(totalSeconds-1);
      }, 1000);
    },
    shareToHandler() {
      const platform = "WX";
      const text =
        localStorage.getItem('shareDesc');
      const title = localStorage.getItem('shareTitle');
      const imageUrl = localStorage.getItem('shareImgUrl');
      const titleUrl = this.shareUrl;
      const url = this.shareUrl;
      const description = "";
      const site = "作业盒子家长端";
      const siteUrl = this.shareUrl;
      const callback = "(result) => window.shareCallback(result)";
      
      share(
        platform,
        text,
        title,
        imageUrl,
        titleUrl,
        url,
        description,
        site,
        siteUrl,
        callback,
      );
      setTimeout(()=>{
        if(!localStorage.getItem('isShowPopup')){
          this.isShowPopup = true;
        }
      },2000)
    },
    close(){
      this.isShowPopup = false;
      localStorage.setItem('isShowPopup',false);
    },
    shareToWx(){   

    },

  }
};
</script>

<style lang="scss" scoped>
.no_group {
  width: 100%;
  position: relative;
  overflow: hidden;
  .group_status {
    width: 100%;
    height: 0.84rem;
    background-color: #ff5c5c;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      margin-left: 0.4rem;
      font-size: 0.26rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
      display: flex;
      align-items: center;
      span {
        text-align: center;
        display: block;
        width: 0.46rem;
        height: 0.52rem;
        line-height: 0.52rem;
        background-color: #ffffff;
        border-radius: 0.04rem;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        font-weight: bolder;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ff5c5c;
        margin: 0 0.13rem;
        &:nth-child(1) {
          margin-left: 0.22rem;
        }
      }
    }
    > span {
      margin-right: 0.44rem;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      font-weight: bolder;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
    }
  }
  .title {
    font-family: PingFangSC-Regular;
    font-size: 0.36rem;
    height: 0.36rem;
    line-height: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #5f6162;
    margin: 0.42rem 0 0.97rem 0.41rem;
  }
  .rest_group_num {
    width: 100%;
    height: 0.31rem;
    line-height: 0.32rem;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #5f6162;
    text-align: center;
    margin: 0.39rem 0 0.58rem;
    span {
      font-size: 0.34rem;
      font-weight: normal;
      letter-spacing: 0px;
      color: #ff7070;
    }
  }
  button {
    width: 6rem;
    height: 1rem;
    background-color: #37df72;
    border-radius: 0.5rem;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: calc((100% - 6rem) / 2);
    img {
      width: 0.45rem;
      height: 0.38rem;
      margin-right: 0.15rem;
    }
  }
  .tips {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #bec0c2;
    margin: 0.21rem 0 0.82rem;
    img {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: .07rem;
    }
      width: 100%;
      text-align: center;
      span {
        color: #919294;
      }
    
  }
}
</style>